import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { ProfileRole } from '../../types'

export const NavbarContainer = styled.nav<{
  $isOpen: boolean
  $userRole: ProfileRole | null
}>`
  width: 100%;
  height: 100vh;
  background-color: ${(props) =>
    props.$userRole === 'admin'
      ? '#fdfdfd'
      : props.$userRole === 'professor'
        ? '#BDDDEB'
        : '#FFDC50'};
  display: flex;
  padding-top: 32px;
  padding-bottom: 73px;
  align-items: center;
  flex-direction: column;
  transition: transform 0.3s ease-in-out;

  @media (max-width: 1024px) {
    transform: translateX(${(props) => (props.$isOpen ? '0' : '-100%')});
  }
`

export const ToggleButton = styled.button<{ $isOpen: boolean }>`
  position: fixed;
  top: ${(props) => (props.$isOpen ? '0' : '24px')};
  left: ${(props) => (props.$isOpen ? '172px' : '24px')};
  background-color: transparent;
  color: #0a0a18;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 1001;
  font-size: 24px;
  border: ${(props) => (props.$isOpen ? 'none' : '1px solid #FFDC50')};
  border-radius: 50%;
  transition: left 0.3s ease-in-out;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 1025px) {
    display: none;
  }
`

export const LogoContainer = styled.div`
  display: flex;
  width: 193px;
  height: 40px;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 60px;

  img {
    width: 40px;
    height: 40px;
  }

  p {
    font-size: 32px;
    font-style: normal;
    font-weight: 600;

    @media screen and (max-width: 1024px) {
      font-size: 27px;
    }
  }
`

export const NavbarLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 192px;
  gap: 24px;
  justify-content: flex-start;

  .nav-link {
    width: 192px;
    padding: 10px 20px;
    display: flex;
    gap: 12px;
    font-size: 14px;
    font-weight: 500;
    color: #8e92bc;
    border-radius: 10px;
    align-items: center;

    svg {
      font-size: 24px;
    }

    &.active {
      background: #f6f6f6;
      color: #0a0a18;

      svg {
        color: #08a8d2;
      }
    }

    &:hover {
      background: #f6f6f6;
    }
  }
`
export const NavbarLink = styled(Link)`
  color: white;
  text-decoration: none;
  &:hover,
  &:focus {
    background: #f6f6f6;
  }
`
export const HelpContainer = styled.div``
